// extracted by mini-css-extract-plugin
export default {"mainContent":"build-water-heater-system_mainContent__DUfHd"};